import { render, staticRenderFns } from "./init.vue?vue&type=template&id=0b3f0f8f&scoped=true&"
import script from "./init.ts?vue&type=script&lang=ts&"
export * from "./init.ts?vue&type=script&lang=ts&"
import style0 from "./init.css?vue&type=style&index=0&id=0b3f0f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f0f8f",
  null
  
)

component.options.__file = "init.vue"
export default component.exports